import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import {setPickupValue, setShippingValue, getShippingCost, setShippingToCart } from '../actions/nShippingActions'
import { NLoader } from "./NLoader";
import { YMaps, Map, Placemark } from 'react-yandex-maps';

const NShipping  = props => {
  const {shipping_data, setShippingValue, setPickupValue, getShippingCost, setShippingToCart} = props;
  const {map_type, key, method, status, variants, variant} = shipping_data;


  const [visibleMethod, setVisibleMethod] = useState(method);
  const [shippingValue, setValue] = useState(variants.shipping.value);
  const [deliveryChanged, setDeliveryChanged] = useState(false);
  const isFetching = status === "FETCHING" ? true : false;
  const title = method==="shipping" ? variants.shipping.title  : variants.pickup.title
  const total = method==="shipping" ? variants.shipping.total : variants.pickup.total
  const not_loaded = (props.cart_items.length === 0 && props.cart_num_items > 0) ? true : false;

  useEffect(() => {

      // не запрашиваем при начальной инициализации компонента
      setVisibleMethod(method);
      //setValue(value);

  },[method]);

  useEffect(() => {

      // не запрашиваем при начальной инициализации компонента
      setValue(variants.shipping.value);

  },[variants.shipping.value]);

  const safeSetShipping = (variant_id) =>{

      if(variants.shipping.variants.length > 0){
          let current_variant = variants.shipping.variants.find(function (element) {
              return element.id === variant_id;
          });
          if (current_variant===undefined){
              current_variant = variants.shipping.variants[0]
          }
          // переустанавливаем данные доставки из варианта
          setShippingValue(current_variant);
          return current_variant.id
      }
      return 0
  }

  const safeSetPickUp = (variant_id) =>{

      const pickup_variant = variants.pickup.variants.find(function (element) {
              return element.id === variant_id;
          });

          if (pickup_variant!== undefined){
                setPickupValue(pickup_variant);

                return pickup_variant.id

          }else if (variants.pickup.variants.length > 0){
              setPickupValue(variants.pickup.variants[0]);

              return variants.pickup.variants[0].id
          }

      return 0

  }

  const handleSelectMethod = (e, method) => {
      // переключение вкладок
      e.preventDefault();

      if(visibleMethod!==method && status!=="FETCHING"){
          //setVisibleMethod(method); todo: delete?

          const current_method = variants[method];

          if(method=='shipping'){
              //shipping
              const current_variant_id = safeSetShipping(current_method.variant);

              // сбросить текущие данные доставки если вариант не тот
              if(current_variant_id===0){
                  setShippingValue({
                      calculated: false,
                      id: 0,
                      price: "0.0",
                      title: "Не удалось расчитать стоимость доставки, попробуйте уточнить адрес",
                      delivery: ""
                  })
              }else{

                setShippingToCart();

              }

          }else{

            const current_variant_id = safeSetPickUp(current_method.variant);

            if (current_variant_id!==0){

                setShippingToCart();

            }
          }
      }
  }

  const handleSelectPikupVariant = (e, new_variant) => {

      if(variant!==new_variant){
          const current_variant_id = safeSetPickUp(new_variant)
          if (current_variant_id!==0){
              setShippingToCart();
          }

      }

  }

  const handleSelectShippingVariant = (e, new_variant) => {

      if(variant!==new_variant){
          const current_variant_id = safeSetShipping(new_variant)
          if (current_variant_id!==0){
              setShippingToCart();
          }

      }

  }

  const handleChangeShippingVariant = (value) => {

      setValue(value);
      setDeliveryChanged(true);

  }

  const handleCalcShippingVariant = (e) => {

      getShippingCost(shippingValue, deliveryChanged);

  }

  function renderMap(){
    return(
        map_type === "yandex" && variants.shipping.map && variants.shipping.map.point ?
            <div className="shipping-yandex-map">
                <YMaps>
                    <Map defaultState={{ center: variants.shipping.map.point, zoom: 10}} width="100%">
                        <Placemark geometry={variants.shipping.map.point}
                                   options={{ iconColor: 'red'}}
                                   properties={{balloonContent: variants.shipping.map.address,
                                       hintContent: variants.shipping.map.address}}
                                   modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}
                        />
                    </Map>
                </YMaps>
            </div>
            :
            <div></div>
    )
  }


  function rendePickup(){
      return (
          <div role="tabpanel" className="tab-pane fade in active" id="pickup_tab">
              {variants.pickup.variants.map((item, key) => (
                    <p key={key}>
                        <input name="pickup_group"
                               type="radio"
                               value={item.id}
                               className="radio-col-light-blue"
                               id={`pick_up_radio_${item.id}`}
                               checked={variant === item.id ? 1 : 0}
                               onChange={ e => handleSelectPikupVariant(e, item.id)}
                        />
                        <label className="ncart-radio-label"
                               htmlFor={`pick_up_radio_${item.id}`}>
                            {item.name}
                        </label>
                    </p>
                  ))
              }
          </div>
      )
  }


  function renderShipping(){
      return(
          <div role="tabpanel" className="tab-pane fade in active" id="home_with_icon_title">
                      <b>Укажите адрес доставки</b>
                      <div className="row">
                          <div className="col-md-9">
                              <div className="form-group">
                                  <div className="form-line">
                                      <input type="text"
                                             className="form-control"
                                             placeholder={shippingValue ? "" : "Например: г. Белгород ул. Щорса 9А кв. 111"}
                                             value={shippingValue}
                                             onChange={e => handleChangeShippingVariant(e.currentTarget.value)}
                                      />
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3">
                              {isFetching ?
                                  <button type="button" className="btn btn-block nshipping-calc">РАСЧИТАТЬ</button>
                                  :
                                  <button type="button" className="btn btn-block nshipping-calc" onClick={e => handleCalcShippingVariant(e)}>РАСЧИТАТЬ</button>
                              }
                          </div>
                      </div>
                        {isFetching ? <div className="text-center"><NLoader size="pl-size-xl" /> </div>:
                          <div>
                              {renderMap()}
                              {variants.shipping.variants.map((item, key) => (
                                  <div className="row p-t-20" key={key}>
                                      <div className="col-md-9">
                                          <input name="shipping_group"
                                                 type="radio"
                                                 value={item.id}
                                                 className="radio-col-light-blue"
                                                 id={`shipping_up_radio_${item.id}`}
                                                 checked={variant === item.id ? 1 : 0}
                                                 onChange={e => handleSelectShippingVariant(e, item.id)}
                                          />
                                          <label className="ncart-radio-label"
                                                 htmlFor={`shipping_up_radio_${item.id}`}>
                                              {item.title}
                                          </label>
                                          <p className="shipping-description">
                                              {item.description}
                                          </p>
                                      </div>
                                      <div className="col-md-3">
                                          <div className="ncart-shipping-price">
                                              {((variants.shipping.calculated) && (item.price) && (parseFloat(item.price) > 0)) ?
                                                  <span className="price">{item.price}&nbsp;&#8381;</span>
                                                  :
                                                  <span className="price">по договоренности</span>
                                              }
                                          </div>
                                      </div>
                                  </div>
                              ))
                              }
                          </div>
                      }
                  </div>
      )
  }


  return (
    <>
    <div className="nheader">
      <h2>Способ доставки <span className="help-link pull-right">
          <a href="/oplata-i-dostavka/dostavka/">О доставке <i className="material-icons">help_outline</i></a></span>
      </h2>
    </div>
          <div className={`nbody${not_loaded ? ' blur': '' }`}>
              <ul className="nav nav-tabs" role="tablist">
                  {Object.keys(variants).map((item, key) => (
                      <li role="presentation" key={key}
                          className={`nshipping-method ${visibleMethod === item ? ' active': ''}`}>
                          <a href="#" data-toggle="tab" onClick={ e =>handleSelectMethod(e,item)}>
                          <i className="material-icons">{variants[item].method_icon}</i> {variants[item].method_title}
                          </a>
                      </li>
                  ))}
              </ul>
              <div className="tab-content">
                  {visibleMethod === 'pickup' ? rendePickup() : renderShipping()}
              </div>

          </div>
    </>
)}

const mapStateToProps = state => ({
    cart_status: state.ncart.status,
    cart_num_items: state.ncart.num_items,
    cart_items: state.ncart.items,
    cart_total: state.ncart.total,
    shipping_data: state.nshipping
})

const mapDispatchToProps = dispatch => bindActionCreators({setPickupValue, setShippingValue,
    getShippingCost, setShippingToCart}, dispatch);

export default connect(
  mapStateToProps,
    mapDispatchToProps
)(NShipping)
